import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Cards from 'components/Card';
import { COLUMNS_LIMIT } from 'variables/main';

const Title = styled(Typography)(({ theme }) => ({
  padding: '12px 25px 10px 25px',
  fontSize: 24,
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    lineHeight: '34px'
  },
  [theme.breakpoints.down('sm')]: {
    textAlign: 'left'
  }
}));

const ContentContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}));

const Wrapper = styled('div')(() => ({
  width: '100%'
}));

const ContentWrapper = styled('section')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  width: '100%'
}));

const ButtonStyled = styled(Button)(() => ({
  alignSelf: 'center',
  marginTop: 35
}));

const SimilarProfessionsSlideComponent = ({ professionInfo, t }) => {
  const [page, setPage] = React.useState(1);

  const handleLoad = React.useCallback(async () => {
    setPage(page + 1);
  }, [page]);

  const count = React.useMemo(
    () => (professionInfo.similarOccupations || []).length,
    [professionInfo]
  );

  const list = React.useMemo(() => {
    return (professionInfo.similarOccupations || [])?.slice(0, COLUMNS_LIMIT * page);
  }, [professionInfo.similarOccupations, page]);

  const limitReached = React.useMemo(() => count <= page * COLUMNS_LIMIT, [count, page]);

  if (!professionInfo) return null;

  return (
    <>
      <Title variant={'h1'}>{t('SimilarProfessions')}</Title>

      <ContentContainer>
        <Wrapper>
          <ContentWrapper>
            <Cards list={list} />

            {limitReached ? null : (
              <ButtonStyled
                aria-label={t('MoreProfessions')}
                variant="contained"
                color="primary"
                onClick={handleLoad}>
                {t('MoreProfessions')}
              </ButtonStyled>
            )}
          </ContentWrapper>
        </Wrapper>
      </ContentContainer>
    </>
  );
};

export default SimilarProfessionsSlideComponent;
